module.exports = __webpack_public_path__ + "img/questionmark.6cf5464a.svg";